import { UserContextProject } from 'core/userContext';
import { selectUserProject } from 'core/userContext/selectors';
import { useDispatch, useSelector } from 'react-redux';
import { exportTemplateHTMLRequest } from '../ducks/actions';

/**
 * React hook that returns a function for exporting a template to HTML by id.
 *
 * Only use the function returned by this hook with templates that are exportable
 * (i.e. where the medium is email).
 *
 * @returns {(templateId: number, triggeredBy: SEGMENT_TRACKED_TEMPLATE_ACTION_TRIGGERS[string]) => void} - A function
 * to export a template to HTML. The `triggeredBy` argument is a string used to describe the element triggering
 * this action (for Segment tracking).
 */
export const useExportTemplate = () => {
  const dispatch = useDispatch();
  // @ts-ignore not worrying about root level state typing at the moment
  const currentProject = useSelector(selectUserProject) as UserContextProject;
  return (templateId: number | string, triggeredBy: string) =>
    dispatch(exportTemplateHTMLRequest(templateId, currentProject.name, triggeredBy));
};
